import { DateTime } from 'luxon';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { authActions, authTypes } from 'app-components/flux/auth';
import { datasetsSelectors, datasetsUtils } from 'app-components/flux/datasets';

import DialogContent from '@mui/material/DialogContent';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import StdDialog from 'components/Dialogs/StdDialog';
import Dump from 'components/Dump';

const SelectDatasetDialog = (props) => {
  const { ...otherProps } = props;

  const dispatch = useDispatch();
  const datasets = useSelector(datasetsSelectors.getActiveSortedDatasets);

  return (
    <StdDialog
      sharedcomponentid={'SELECT_DATASET_DIALOG'}
      showCloseButton={false}
      size='sm'
      title='Select Finances'
      {...otherProps}
    >
      <DialogContent>
        <List>
          {datasets.toIndexedSeq().map((dataset) => (
            <ListItemButton
              data-testid={`select-finances-dataset-${dataset.id}`}
              key={dataset.id}
              onClick={() =>
                dispatch(
                  authActions.authSelectDataset(authTypes.AuthSelectDatasetPayload({ dataset, userChoice: true })),
                )
              }
              disabled={!datasetsUtils.hasActiveEntitlement(dataset)}
            >
              <Dump obj={dataset} />
              <ListItemText
                primary={dataset.name}
                secondary={
                  DateTime.fromISO(dataset.lastSyncedAt).isValid &&
                  `last used ${DateTime.fromISO(dataset.lastSyncedAt).toLocaleString(DateTime.DATETIME_MED)}`
                }
              />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
    </StdDialog>
  );
};

export default SelectDatasetDialog;
